import { createSelector } from 'reselect';
import { difference, percentChange } from 'services/Calculation';
import { getRetailTracAccounts, getWorkplaceAccounts } from 'state/account/AccountSelectors';

const formatAccounts = (accounts, type, key) => {
  return accounts.reduce((arr, account) => {
    const {
      balanceValue,
      previousBalanceValue,
      accountName,
      owner,
      owners,
      accountType,
      productType,
      accountId,
      isViewOnly,
      isRelated,
      sweepAccount,
      rpsPlanNumber
    } = account;

    const priceChangePercentSum = percentChange(
      account.balanceValue,
      account.previousBalanceValue
    );
    const nameAndChecksum = `${accountName}`.trim();
    const accountDescriptor = `${accountName}`;
    const diff = difference(balanceValue, previousBalanceValue);
    const isOwner = owner
      ? 'Owned'
      : isRelated
      ? 'Related'
      : isViewOnly
      ? 'View Only'
      : '';
    const ownerName = owners.find((curr) => curr.primaryOwner);
    const primaryOwner = `${accountType}${
      ownerName ? '\n' + ownerName.ownerName : ''
    }`;
    const balance = balanceValue || 0;

    return [
      ...arr,
      {
        balance,
        balanceValue,
        difference: diff,
        priceChangePercentSum,
        productType,
        nameAndChecksum,
        owner,
        isOwner,
        primaryOwner,
        previousBalanceValue,
        accountId,
        accountDescriptor,
        isViewOnly,
        sweepAccount,
        rpsPlanNumber,
        [key]: type
      }
    ];
  }, []);
}

export const getWorkplaceGridAccounts = createSelector(
    getWorkplaceAccounts,
    (accounts) => formatAccounts(accounts, 'Workplace Retirement', 'workplaceRetirement')
);

export const getTracGridAccounts = createSelector(
    getRetailTracAccounts,
    (accounts) => formatAccounts(accounts, 'Small Business Retirement', 'tracRetailRetirement')
);
